var map = {
	"./loading.svg": "a044",
	"./lrc.svg": "1cf2",
	"./menu.svg": "dc52",
	"./no-repeat.svg": "1679",
	"./pause.svg": "38bc",
	"./play.svg": "0f12",
	"./repeat-all-legacy.svg": "02df",
	"./repeat-all.svg": "f5c0",
	"./repeat-one-legacy.svg": "cae2",
	"./repeat-one.svg": "c59f",
	"./shuffle.svg": "802e",
	"./skip.svg": "9c43",
	"./volume-down.svg": "45aa",
	"./volume-off.svg": "3d80",
	"./volume-up.svg": "cc49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f791";